import styled from 'styled-components';
import fonts from '../../../helpers/fonts';
import mediaQuery from '../../../helpers/mediaQuery';
import spacing from '../../../helpers/spacing';
import { Grid } from '../../Grid';

export const Heading = styled.h2`
  ${fonts.headingMedium};
  text-align: center;

  margin: 0;
`;

export const Subheading = styled.p`
  ${fonts.paragraphLarge};
  text-align: center;

  margin: 0;
`;

export const Body = styled.p`
  ${fonts.paragraph};
  margin: ${spacing(3)} 0 ${spacing(4)};
`;

type ReverseMobileLayoutProps = {
  reverseMobileLayout: boolean;
};

export const HeadingsWrapper = styled.div<ReverseMobileLayoutProps>`
  margin-bottom: ${(props) => (props.reverseMobileLayout ? 0 : spacing(2))};
  margin-top: ${(props) => (props.reverseMobileLayout ? spacing(2) : 0)};

  ${mediaQuery.tabletPortrait`
    margin-top: 0;
    margin-bottom: ${spacing(3)};
  `}

  ${mediaQuery.tabletLandscape`
    margin-bottom: ${spacing(4)};
  `}

  h2 + p {
    margin: ${spacing(1)} 0 0;

    ${mediaQuery.tabletPortrait`
      margin-top: ${spacing(2)};
    `}
  }
`;

export const ReverseLayoutMobile = styled.div<ReverseMobileLayoutProps>`
  display: flex;
  flex-flow: ${(props) => (props.reverseMobileLayout ? 'column-reverse' : 'column')};

  ${mediaQuery.tabletPortrait`
    flex-flow: column;
  `}
`;

export const CtaWrapper = styled.div`
  display: flex;
  justify-content: center;

  margin-top: ${spacing(2)};

  ${mediaQuery.tabletPortrait`
    margin-top: ${spacing(3)};
  `}

  ${mediaQuery.tabletLandscape`
    margin-top: ${spacing(4)};
  `}
`;

export const GridWithMargins = styled(Grid)`
  && {
    margin-top: ${spacing(3)};
    margin-bottom: ${spacing(3)};

    ${mediaQuery.tabletLandscape`
      margin-top: ${spacing(4)};
      margin-bottom: ${spacing(4)};
    `}
  }
`;
